// Translations
import server from './server'

// Translation: English > Notices
const notices = Object.freeze({
	error: {
		client: {
			appleSignInPopupBlockedError: 'Please allow pop-ups to sign in with Apple.',
			appleSignUpPopupBlockedError: 'Please allow pop-ups to sign up with Apple.',
			applicationTokenFetchingError: 'Unable to login.',
			capthchaExpiredError: 'Captcha is expired.',
			capthchaNotLoadedError: 'Captcha has not been loaded.',
			emailVerificationCodeResendingError: 'We were unable to send a verification code.',
			passwordResetCodeResendingError: 'A password reset code cannot be requested.',
			passwordResetError: 'Password reset was unsuccessful. Please review your request and try again.',
			passwordResetRequestError: 'We encountered an error while handling your password reset request.',
			providerAuthenticationError: 'Unable to authenticate with the provider.',
			registrationError: 'Registration was unsuccessful. Please review your request and try again.',
			unavailableCaptchaTokenError: 'Captcha token is not available.',
			verificationError: 'Verification has failed. Please review your request and try again.'
		},
		fallback: 'An error occured. Please verify your request, and try again.',
		server: server.errorItems
	},
	success: {
		fallback: 'Operation is successful!',
		passwordChangeSuccess: 'Password is changed.'
	},
	warning: {
		form: {
			hasAtLeast8CharactersWarning: 'This value should have at least 8 characters.',
			hasLowerCaseLetterWarning: 'This value should have a lowercase character.',
			hasMatchingValueWarning: 'This value should match the previous value.',
			hasNonEmptyValueWarning: 'This value should not be empty.',
			hasNumberWarning: 'This value should have a number.',
			hasSpecialCharacterWarning: 'This value should have a special character.',
			hasUnusedValueWarning: 'This value is already in use.',
			hasUpperCaseLetterWarning: 'This value should have an uppercase character.',
			isEmailWarning: 'Please enter a valid email address.',
			isPersonNameWarning: 'Please enter a valid name.',
			isPhoneNumberWarning: 'Please enter a valid phone number.',
			isURLWarning: 'Please enter a valid URL (domain address).'
		}
	}
})

// Export
export default notices
